/**
 * Automatisch uitloggen in het beheer na een tijd zonder activiteit (klantgegevens, kassa, omzet op
 * een gedeelde salon-pc). De server houdt de sessie zelf ook bij; dit is de extra stap in de browser.
 * Puur, zonder React (admin/security/IdleLogout.tsx gebruikt dit).
 */

export const IDLE_LIMIT_MS = 30 * 60_000
/** Zo vaak hoogstens de gedeelde "laatst actief" bijwerken: niet bij elke muisbeweging schrijven. */
export const ACTIVITY_WRITE_MS = 30_000
/** Gedeeld tussen tabbladen: werk in het ene tabblad houdt het andere ingelogd (uitloggen geldt voor allebei). */
export const ACTIVITY_KEY = 'bb-admin-active'

export type IdleDecision = 'stay' | 'logout' | 'keep-work'

/**
 * - Recent actief (in een van de tabbladen): blijven.
 * - Te lang stil zonder open werk: uitloggen.
 * - Te lang stil mét niet-opgeslagen werk: niet uitloggen (dat zou het werk weggooien); de server
 *   vraagt bij een gevoelige actie toch opnieuw om het wachtwoord (423).
 */
export function idleDecision(now: number, lastActive: number, hasWork: boolean, limit = IDLE_LIMIT_MS): IdleDecision {
  if (!Number.isFinite(lastActive) || now - lastActive < limit) return 'stay'
  return hasWork ? 'keep-work' : 'logout'
}

/** De laatste activiteit: de nieuwste van dit tabblad en de gedeelde waarde. Onzin telt niet. */
export function lastActivity(local: number, shared: string | null): number {
  const s = Number(shared)
  return Number.isFinite(s) && s > 0 ? Math.max(local, s) : local
}
